import { Tag } from 'antd';

export const getRentalErrorMessage = (error) => error?.response?.data?.message
  || error?.response?.data?.reason
  || 'Không thể xử lý yêu cầu cho thuê xe';

export const formatMoney = (value) => (value == null ? '—' : `${Number(value).toLocaleString('vi-VN')} ₫`);
export const formatDateTime = (value) => (value ? new Date(value).toLocaleString('vi-VN') : '—');
export const formatDate = (value) => (value ? new Date(value).toLocaleDateString('vi-VN') : '—');

export const PARTNER_STATUS_META = {
  PENDING: ['Chờ duyệt', 'processing'],
  APPROVED: ['Đã duyệt', 'success'],
  REJECTED: ['Từ chối', 'error'],
  SUSPENDED: ['Tạm ngưng', 'default'],
};
export const PARTNER_STATUS_OPTIONS = [
  { value: '', label: 'Tất cả trạng thái' },
  ...Object.entries(PARTNER_STATUS_META).map(([value, [label]]) => ({ value, label })),
];
export function PartnerStatusTag({ status }) {
  const [label, color] = PARTNER_STATUS_META[status] || [status || 'Không rõ', 'default'];
  return <Tag color={color}>{label}</Tag>;
}

export const VEHICLE_STATUS_META = {
  PENDING_DEPOSIT: ['Chờ đặt cọc', 'warning'],
  ACTIVE: ['Đang hoạt động', 'success'],
  RENTED: ['Đang cho thuê', 'processing'],
  MAINTENANCE: ['Bảo trì', 'default'],
  RETIRED: ['Ngừng hoạt động', 'default'],
  OWNERSHIP_TRANSFERRED: ['Đã sang tên', 'blue'],
};
export function VehicleStatusTag({ status }) {
  const [label, color] = VEHICLE_STATUS_META[status] || [status || 'Không rõ', 'default'];
  return <Tag color={color}>{label}</Tag>;
}

export const DEPOSIT_STATUS_META = {
  PENDING_CONFIRMATION: ['Chờ xác nhận', 'processing'],
  CONFIRMED: ['Đã xác nhận', 'success'],
  REJECTED: ['Từ chối', 'error'],
};
export const DEPOSIT_STATUS_OPTIONS = [
  { value: '', label: 'Tất cả trạng thái' },
  ...Object.entries(DEPOSIT_STATUS_META).map(([value, [label]]) => ({ value, label })),
];
export function DepositStatusTag({ status }) {
  const [label, color] = DEPOSIT_STATUS_META[status] || [status || 'Không rõ', 'default'];
  return <Tag color={color}>{label}</Tag>;
}

export const LICENSE_STATUS_META = {
  PENDING: ['Chờ duyệt', 'processing'],
  VERIFIED: ['Đã xác minh', 'success'],
  REJECTED: ['Từ chối', 'error'],
};
export const LICENSE_STATUS_OPTIONS = [
  { value: '', label: 'Tất cả trạng thái' },
  ...Object.entries(LICENSE_STATUS_META).map(([value, [label]]) => ({ value, label })),
];
export function LicenseStatusTag({ status }) {
  const [label, color] = LICENSE_STATUS_META[status] || [status || 'Không rõ', 'default'];
  return <Tag color={color}>{label}</Tag>;
}

export const ORDER_STATUS_META = {
  PENDING_DRIVER: ['Chờ đối tác nhận', 'processing'],
  PENDING_HANDOVER: ['Chờ giao xe', 'warning'],
  ACTIVE: ['Đang thuê', 'blue'],
  COMPLETED: ['Hoàn thành', 'success'],
  CANCELLED: ['Đã huỷ', 'default'],
  REJECTED: ['Từ chối', 'error'],
};
export const ORDER_STATUS_OPTIONS = [
  { value: '', label: 'Tất cả trạng thái' },
  ...Object.entries(ORDER_STATUS_META).map(([value, [label]]) => ({ value, label })),
];
export function OrderStatusTag({ status }) {
  const [label, color] = ORDER_STATUS_META[status] || [status || 'Không rõ', 'default'];
  return <Tag color={color}>{label}</Tag>;
}

export const DAMAGE_STATUS_META = {
  OPEN: ['Chưa xử lý', 'error'],
  RESOLVED: ['Đã xử lý', 'success'],
};
export const DAMAGE_STATUS_OPTIONS = [
  { value: '', label: 'Tất cả trạng thái' },
  ...Object.entries(DAMAGE_STATUS_META).map(([value, [label]]) => ({ value, label })),
];
export function DamageStatusTag({ status }) {
  const [label, color] = DAMAGE_STATUS_META[status] || [status || 'Không rõ', 'default'];
  return <Tag color={color}>{label}</Tag>;
}

export const DAMAGE_SEVERITY_META = {
  MINOR: ['Nhẹ', 'warning'],
  MAJOR: ['Nặng', 'error'],
};
export function DamageSeverityTag({ severity }) {
  const [label, color] = DAMAGE_SEVERITY_META[severity] || [severity || 'Không rõ', 'default'];
  return <Tag color={color}>{label}</Tag>;
}

export const GENDER_LABELS = { MALE: 'Nam', FEMALE: 'Nữ', OTHER: 'Khác' };
export const PARTICIPANT_TYPE_LABELS = {
  INDIVIDUAL: 'Cá nhân',
  HOUSEHOLD: 'Hộ gia đình',
  STOREFRONT: 'Cửa hàng',
};
export const IDENTITY_DOCUMENT_TYPE_LABELS = {
  CCCD: 'Căn cước công dân',
  CMND: 'Chứng minh nhân dân',
  PASSPORT: 'Hộ chiếu',
};
export const LOCATION_TYPE_LABELS = {
  NHA_RIENG: 'Nhà riêng',
  CUA_HANG: 'Cửa hàng',
  KHACH_SAN: 'Khách sạn',
  QUAN_CA_PHE: 'Quán cà phê',
  KHAC: 'Khác',
};
